import { baseApi } from '../../../../app/baseApi';

type WifiDetailsAPIBody = {
  wifi_ssid: string;
  wifi_password: string;
};

type WifiDetailsAPIResponse = {
  device_id: string;
  status_code: number;
}[];

export const wifiApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    updateWifiDetails: builder.mutation<WifiDetailsAPIResponse[], { body: WifiDetailsAPIBody; siteId: number }>({
      query: ({ body, siteId }) => {
        return {
          url: `/fleet/sites/${siteId}/wifi_config`,
          method: 'POST',
          body,
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useUpdateWifiDetailsMutation } = wifiApi;
